module.exports = Promise.all([import("angular"), import("utils/config")]).then(deps => {
    let [angular, config] = deps;

    var app = angular.module("tapServices", []);

    function Storage($http) {
        this.data = null;
        var self = this;
        var inited = false;
        var refreshing = false;
        var getUrl = null;
        var query = null;
        var filters = null;
        var isPaginated = false;
        var next;

        function parseLinkHeader(header) {
            if (header.length == 0) {
                throw new Error("input must not be of zero length");
            }

            var parts = header.split(",");
            var links = {};

            angular.forEach(parts, function(p) {
                if (p.indexOf(";") === -1) return;

                var section = p.split(";");
                if (section.length != 2) {
                    throw new Error("section could not be split on ';'");
                }
                var url = section[0].replace(/<(.*)>/, "$1").trim();
                var name = section[1].replace(/rel="(.*)"/, "$1").trim();
                links[name] = url;
            });

            return links;
        }

        this.init = function(url, callback) {
            this.getUrl = url;
            this.inited = true;

            this.refresh(callback);
        };

        this.get = function() {
            if (!this.inited) return;

            return this.data;
        };

        this.refresh = function(callback, type) {
            var url;
            if (this.refreshing || !this.inited || !this.getUrl) return;

            this.refreshing = true;

            if (type === "next") {
                url = next;
            } else {
                url = this.getUrl;
                var l = url.indexOf("?") === -1 ? "?" : "&";
                if (this.filters) {
                    for (var i = this.filters.length - 1; i >= 0; i--) {
                        url += l + this.filters[i];
                        l = "&";
                    }
                }

                if (this.sortOptions) {
                    for (var i = this.sortOptions.length - 1; i >= 0; i--) {
                        url += l + this.sortOptions[i];
                        l = "&";
                    }
                }

                if (this.query) {
                    url += l + "q=" + this.query;
                }
            }

            $http.get(url).success(function(_data, status, headers) {
                if (headers("link")) {
                    isPaginated = true;
                    next = parseLinkHeader(headers("link")).next || null;
                } else {
                    isPaginated = false;
                }

                if (type === "next") {
                    self.data.push.apply(self.data, _data);
                } else {
                    self.data = _data;
                }

                self.refreshing = false;

                if (typeof callback == "function") callback(_data);
            });
        };

        this.hasNext = function() {
            return next != null;
        };

        this.isPaginated = function() {
            return isPaginated;
        };

        this.setData = function(data) {
            this.inited = true;
            this.refreshing = false;
            this.data = data;
        };

        this.addItem = function(item, prepend) {
            if (prepend) {
                this.data.unshift(item);
            } else {
                this.data.push(item);
            }
        };

        this.removeItem = function(item) {
            if (item.id === undefined) return this.data.splice(this.data.length - 1, 1);

            for (var i = this.data.length - 1; i >= 0; i--) {
                if (
                    (this.data[i].$$hashKey !== undefined && this.data[i].$$hashKey === item.$$hashKey) ||
                    this.data[i].id === item.id
                ) {
                    this.data.splice(i, 1);
                }
            }
        };

        this.patch = function(patches, cb) {
            $http
                .patch(this.getUrl, patches)
                .success(function(result, status, headers) {
                    if (typeof cb === "function") cb(null, result);
                })
                .error(function(err) {
                    if (typeof cb === "function") cb(err);
                })
                .finally();
        };

        this.post = function(data, file, cb) {
            var fd = new FormData();

            fd.append("asset", JSON.stringify(data));

            if (file) {
                fd.append("file", file);
            }

            var self = this;
            $http({
                method: "POST",
                url: this.getUrl,
                headers: { "Content-Type": undefined },
                transformRequest: angular.identity,
                data: fd,
            })
                .success(function(data, status, headers, config) {
                    self.addItem(data, true);
                    if (typeof cb === "function") cb();
                })
                .error(function(data, status, headers, config) {
                    import("flash-message").then(showFlash => {
                        showFlash = showFlash.default;
                        if (data && data.errors) {
                            angular.forEach(data.errors, function(error) {
                                showFlash("warning", error.message);
                            });
                        } else {
                            showFlash(
                                "warning",
                                "An unknown error occurred. If the problem persists, please contact support.",
                            );
                        }
                    });

                    if (typeof cb === "function") cb(true);
                });
        };

        this.setFilter = function(filter) {
            if (filter && filter.constructor !== Array) filter = [filter];
            this.filters = filter;
        };

        this.setSorting = function(sortOption) {
            if (sortOption && sortOption.constructor !== Array) sortOption = [sortOption];
            this.sortOptions = sortOption;
        };

        this.setQuery = function(q) {
            this.query = q;
        };

        this.isRefreshing = function() {
            return this.refreshing;
        };
    }

    app.factory("storageFactory", [
        "$http",
        function($http) {
            var instances = {};
            // TODO: Weird side effect
            $http.defaults.headers.common["X-Csrf-Token"] = config.get("csrf_token");

            return {
                getInstance: function(id) {
                    if (!instances[id]) {
                        instances[id] = new Storage($http);
                    }

                    return instances[id];
                },
            };
        },
    ]);
});
